<template>
  <div class="holev-gap">
    <div class="btn-resource-add d-flex justify-end">
      <v-btn
        large
        depressed
        max-height="32px"
        color="#fecd06"
        class="button-type-1"
        @click="appendResource"
      >
        <v-icon left> mdi-plus </v-icon>
        이미지 소재추가
      </v-btn>
    </div>
    <div
      class="resource-cont relative white rounded pa-6 pb-8 pr-16"
      v-for="(resource, i) in this.resources"
      :key="i"
    >
      <!-- resource-box -->
      <div class="resource-box relative">
        <!-- 소재명 -->
        <v-form v-model="valid[i]">
          <div class="form-row-1">
            <p class="label">
              소재명
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-text-field
                v-model="resource.name"
                label="첨부할 이미지 소재명을 입력해주세요. (한글/영문 20자이내)"
                class="input-custom-2"
                height="40px"
                solo
                :rules="subjectTitleRules"
              ></v-text-field>
            </div>
          </div>
        </v-form>
        <!-- //소재명 -->
        <!-- 예약설정 -->
        <div class="form-row-1 mb-8">
          <p class="label">
            예약설정
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <div class="datepicker-type-1">
              <v-icon>mdi-calendar-blank</v-icon>
              <date-range-picker
                ref="picker"
                v-model="resource.dateRange"
                :date-format="dateFormat"
                :locale-data="localeData"
                :ranges="false"
                :time-picker="true"
                :time-picker-seconds="true"
                :time-picker-increment="1"
                opens="right"
                @update="updateDateRange(resource)"
              >
                <template v-slot:input="picker" style="min-width: 350px">
                  {{ picker.startDate | moment('YYYY.MM.DD HH:mm:ss') }}
                  <span class="ml-3 mr-3"> ~ </span>
                  {{ picker.endDate | moment('YYYY.MM.DD HH:mm:ss') }}
                </template>
              </date-range-picker>
            </div>
          </div>
        </div>
        <!--// 예약설정 -->
        <!-- 파일업로드 -->
        <div class="form-row-1 mb-8" style="border: 1p solid blue">
          <p class="label">
            파일첨부
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <div class="d-flex">
              <!-- 고해상도 -->
              <div class="file-upload-box-2" style="width: 50%">
                <!-- reource에 파일이 있으면 보이도록 -->
                <div v-if="resource.file">
                  <div v-if="!file[i].thumb" class="file-thumb">
                    <img
                      :src="resource.file_thumb1"
                      style="width: 84px"
                      alt=""
                    />
                  </div>
                  <div v-else class="file-thumb">
                    <img :src="file[i].thumb" style="width: 84px" alt="" />
                  </div>
                </div>
                <!-- reource에 파일이 없고 등록할 때 보이도록 -->
                <div v-else class="file-thumb">
                  <img v-if="file[i].thumb" :src="file[i].thumb" alt="" />
                  <v-icon v-else>mdi-image-outline</v-icon>
                </div>
                <div class="file-text">
                  <div class="d-flex">
                    <div class="file-wrap">
                      <v-btn
                        large
                        depressed
                        max-height="32px"
                        color="#fecd06"
                        class="button-type-1"
                        type="file"
                      >
                        파일 업로드
                      </v-btn>
                      <input
                        type="file"
                        @change="onFileChange($event, i)"
                        accept="image/*"
                        :id="`fileUploader1${i}`"
                      />
                    </div>
                    <v-btn
                      large
                      depressed
                      max-height="32px"
                      color="#fecd06"
                      class="button-type-1 ml-2"
                      @click.stop="viewHistory(i)"
                    >
                      광고주소재이력
                    </v-btn>
                  </div>
                  <p class="form-coment-1 my-1 mt-3">
                    <v-icon>mdi-alert-circle-outline</v-icon>
                    JPG 형식만 사용 가능합니다. (고해상도 1920*1200)
                  </p>
                  <div v-if="!resource.file || file.thumb">
                    <p class="file-name mb-0" v-if="file.name">
                      {{ file.name }}
                    </p>
                  </div>
                </div>
              </div>
              <!--// 고해상도 -->
              <!-- 저해상도 -->
              <div class="file-upload-box-2" style="width: 50%">
                <!-- reource에 파일이 있으면 보이도록 -->
                <div v-if="resource.file">
                  <div v-if="!file2[i].thumb" class="file-thumb">
                    <img
                      :src="resource.file_thumb2"
                      style="width: 84px"
                      alt=""
                    />
                  </div>
                  <div v-else class="file-thumb">
                    <img :src="file2[i].thumb" style="width: 84px" alt="" />
                  </div>
                </div>
                <!-- reource에 파일이 없고 등록할 때 보이도록 -->
                <div v-else class="file-thumb">
                  <img v-if="file2[i].thumb" :src="file2[i].thumb" alt="" />
                  <v-icon v-else>mdi-image-outline</v-icon>
                </div>
                <div class="file-text">
                  <div class="d-flex">
                    <div class="file-wrap">
                      <v-btn
                        large
                        depressed
                        max-height="32px"
                        color="#fecd06"
                        class="button-type-1"
                        type="file"
                      >
                        파일 업로드
                      </v-btn>
                      <input
                        type="file"
                        @change="onFileChangeLow($event, i)"
                        accept="image/*"
                        :id="`fileUploader2${i}`"
                      />
                    </div>
                    <v-btn
                      large
                      depressed
                      max-height="32px"
                      color="#fecd06"
                      class="button-type-1 ml-2"
                      @click.stop="viewHistory(i)"
                    >
                      광고주소재이력
                    </v-btn>
                  </div>
                  <p class="form-coment-1 my-1 mt-3">
                    <v-icon>mdi-alert-circle-outline</v-icon>
                    JPG 형식만 사용 가능합니다. (저해상도 1024*768)
                  </p>
                  <div v-if="!resource.file || file2.thumb">
                    <p class="file-name mb-0" v-if="file2.name">
                      {{ file2.name }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- //저해상도 -->
            </div>
            <p class="form-coment-1 mt-2">
              <v-icon>mdi-alert-circle-outline</v-icon>
              홀로딩 소재 이미지 수정이 필요한 경우, 고해상도/저해상도 이미지
              모두 등록해주세요. (개별 수정 불가)
            </p>
          </div>
        </div>
        <!-- //파일업로드 -->
        <!-- 소재삭제버튼 -->
        <a
          href="javascript:void(0);"
          class="btn-ico-delete"
          @click="openRemoveConfirmPopup(resource, i)"
        >
          <v-icon>mdi-delete</v-icon>
        </a>
        <!--// 소재삭제버튼 -->
        <!-- 소재저장 버튼-->
        <div class="d-flex justify-center">
          <div v-if="!resource.id">
            <v-btn
              large
              depressed
              max-height="32px"
              color="#fecd06"
              class="button-type-1"
              type="button"
              :disabled="!valid[i] || !file[i].thumb || !file2[i].thumb"
              @click.prevent="saveResources(resource, i)"
            >
              저장
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              large
              depressed
              max-height="32px"
              color="#fecd06"
              class="button-type-1"
              type="button"
              :disabled="!valid[i]"
              @click="updateResources(resource, i)"
            >
              수정
            </v-btn>
          </div>
        </div>
        <!-- //소재저장 버튼 -->
      </div>
      <!-- //resource-box -->
    </div>
    <SystemAlert v-model="confirmSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click="removeResource"
        >
          확인
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fff"
          class="button-type-1 ml-2"
          @click.stop="confirmSystemAlert = false"
        >
          취소
        </v-btn>
      </div>
    </SystemAlert>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
    <div v-if="showResources">
      <ResourceHistory
        v-model="showResources"
        :propsInventory="propsInventory"
        :propsAdvertiserId="propsAdvertiserId"
        :propsResourceIndex="editItemIndex"
        @historyImgregitst="updateHistoryImg"
      />
    </div>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import { addResource, updateResource, deleteResource } from '@/api/campaign';
import SystemAlert from '~@/modal/SystemAlert.vue';
import { issueUploadPermissions, uploadToS3 } from '@/api/etc';
import { toISOFormattedDate } from '@/utils/validation';
import DateRangePicker from 'vue2-daterange-picker';
import ResourceHistory from '~@/modal/ResourceHistoryModal.vue';

export default {
  components: {
    DateRangePicker,
    SystemAlert,
    ResourceHistory,
  },
  props: {
    propsInventoryType: String,
    propsInventoryId: String,
    propsInventory: Object,
    propsLineItemId: String,
    propsLriId: String,
    propsResources: Array,
    propsAdvertiserId: String,
  },
  data: () => ({
    valid: [false],
    subjectTitleRules: [
      v => !!v || '소재명을 입력해주세요.',
      v =>
        (v && /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|_\-\s]+$/.test(v)) ||
        '한글/영문 20자 이내로 입력해주세요.',
      v => (v && v.length <= 20) || '한글/영문 20자 이내로 입력해주세요.',
    ],
    localeData: {
      format: `yyyy-mm-dd HH:MM:ss`,
      applyLabel: '확인',
      cancelLabel: '취소',
      separator: '　~　',
    },

    file: [
      {
        img: null,
        name: null,
        thumb: null,
        path: null,
        type: 1,
      },
    ],

    file2: [
      {
        img: null,
        name: null,
        thumb: null,
        path: null,
        type: 1,
      },
    ],

    fileCnt: 2,
    fileCategory: 'mrjpg',
    preFilePath: '',

    defaultResource: {
      dateRange: { startDate: null, endDate: null },
      name: '',
      start_at: null,
      end_at: null,
      is_valid: 'Y',
      type: 1,
      hash: '',
      file: '',
      file_thumb1: '',
      file_thumb2: '',
    },
    showSystemAlert: false,
    confirmSystemAlert: false,
    logResult: '',
    editItem: {},
    editItemIndex: null,

    showResources: false,
  }),
  computed: {
    resources: {
      get() {
        let arr = [];
        (this.propsResources || []).map(resource => {
          if (resource.type === 1) {
            let obj = {
              startDate: resource.start_at,
              endDate: resource.end_at,
            };
            resource.dateRange = obj;
            if (resource.file.includes('/%s.jpg')) {
              resource.file_thumb1 = resource.file.replace('/%s.jpg', '/h.jpg');
              resource.file_thumb2 = resource.file.replace('/%s.jpg', '/u.jpg');
            }
            arr.push(resource);
          }
        });
        return arr;
      },
      set(value) {
        this.propsResources = value;
      },
    },
    defaultStartAt() {
      return this.propsInventory.start_at;
    },
    defaultEndAt() {
      return this.propsInventory.end_at;
    },
  },
  methods: {
    dateFormat(classes, date) {
      if (!classes.disabled) {
        if (date < this.$moment(this.propsInventory.start_at)) {
          classes.disabled = true;
        }
        if (date > this.$moment(this.propsInventory.end_at)) {
          classes.disabled = true;
        }
      }
      return classes;
    },
    onFileChange(e, i) {
      const targetFile = e.target.files[0];
      if (targetFile.type === 'image/jpeg') {
        this.file[i].name = targetFile.name;
        this.file[i].thumb = URL.createObjectURL(targetFile);
        this.file[i].img = targetFile;
        this.file[i].type = 1;
      } else {
        this.showSystemAlert = true;
        this.logResult = 'JPG형식만 사용 가능 합니다.';
      }
      document.getElementById(`fileUploader1${i}`).value = '';
    },
    onFileChangeLow(e, i) {
      const targetFile2 = e.target.files[0];
      if (targetFile2.type === 'image/jpeg') {
        this.file2[i].name = targetFile2.name;
        this.file2[i].thumb = URL.createObjectURL(targetFile2);
        this.file2[i].img = targetFile2;
        this.file2[i].type = 1;
      } else {
        this.showSystemAlert = true;
        this.logResult = 'JPG형식만 사용 가능 합니다.';
      }
      document.getElementById(`fileUploader2${i}`).value = '';
    },
    // 고·저해상도 이미지를 저장 시점에 발급받은 키로 업로드하고 고해상도 경로를 반환한다
    async uploadResourceFiles(i) {
      const permissions = await issueUploadPermissions(
        this.fileCategory,
        this.fileCnt,
      );
      await Promise.all(
        permissions.map(permission =>
          uploadToS3(
            permission,
            permission.key.includes('/h.jpg')
              ? this.file[i].img
              : this.file2[i].img,
          ),
        ),
      );
      return permissions.find(p => p.key.includes('/h.jpg')).uploadImagePath;
    },
    // 새로 고른 이미지가 있으면 업로드한다 (실패하면 false 를 반환해 저장하지 않는다)
    async uploadIfSelected(i) {
      if (this.preFilePath) return true;
      if (!this.file[i].img && !this.file2[i].img) return true;
      if (!this.file[i].img || !this.file2[i].img) {
        this.showSystemAlert = true;
        this.logResult = '고해상도, 저해상도 이미지를 모두 선택해주세요.';
        return false;
      }
      try {
        this.preFilePath = await this.uploadResourceFiles(i);
        return true;
      } catch (error) {
        console.log(error.response);
        this.showSystemAlert = true;
        this.logResult = '이미지 업로드에 실패하였습니다. 다시 시도해주세요.';
        return false;
      }
    },

    setDetailResourceIfEmpty() {
      if (this.propsResources.length === 0) {
        this.defaultResource.dateRange.startDate = this.defaultStartAt;
        this.defaultResource.dateRange.endDate = this.defaultEndAt;
        this.defaultResource.start_at = this.defaultStartAt;
        this.defaultResource.end_at = this.defaultEndAt;
        this.propsResources.push(
          JSON.parse(JSON.stringify(this.defaultResource)),
        );
      }
    },

    async saveResources(resource, i) {
      if (!this.propsLriId) {
        this.showSystemAlert = true;
        this.logResult = '홀을 선택 해주세요';
      } else {
        if (!(await this.uploadIfSelected(i))) return;
        const campaignId = this.$route.params.id;
        const inventoryId = this.propsInventoryId;
        const lineItemId = this.propsLineItemId;
        const lriId = this.propsLriId;

        resource.name = resource.name.trim();
        resource.start_at = toISOFormattedDate(new Date(resource.start_at));
        resource.end_at = toISOFormattedDate(new Date(resource.end_at));

        let customFilePath = this.preFilePath.replace('/h.jpg', '/%s.jpg');
        resource.file = customFilePath;
        try {
          const { data } = await addResource(
            campaignId,
            inventoryId,
            lineItemId,
            lriId,
            resource,
          );
          if (data.result === 'success') {
            this.file[i].img = null;
            this.file2[i].img = null;
            this.preFilePath = '';
            const emitData = {
              resourceId: data.value,
              lriId: this.propsLriId,
              resourceType: 1,
            };
            this.$emit('getResourceAfterAdd', emitData);
            this.logResult = '저장되었습니다.';
            this.showSystemAlert = true;
          }
        } catch (error) {
          console.log(error.response);
          const { data } = error.response;
          if (data.result === 'OutRange') {
            this.showSystemAlert = true;
            this.logResult =
              '소재의 시작/종료는 지면의 시작, 종료일 범위 내에서만 설정 가능합니다.';
          } else if (data.result === 'IsAlreadyReserved') {
            this.showSystemAlert = true;
            this.logResult = '선택된 지면은 현재 집행중인 캠페인이 있습니다.';
          } else {
            return false;
          }
        }
      }
    },
    async updateResources(resource, i) {
      if (!(await this.uploadIfSelected(i))) return;
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.propsLineItemId;
      const lriId = this.propsLriId;
      const resourceId = resource.id;

      let updateResourceFile = '';
      if (this.preFilePath && resource.file !== this.preFilePath) {
        updateResourceFile = this.preFilePath.replace('/h.jpg', '/%s.jpg');
      } else {
        updateResourceFile = resource.file;
      }

      const resourceData = {
        type: 1,
        name: resource.name.trim(),
        start_at: toISOFormattedDate(new Date(resource.start_at)),
        end_at: toISOFormattedDate(new Date(resource.end_at)),
        file: updateResourceFile,
        hash: resource.hash,
      };
      try {
        const { data } = await updateResource(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          resourceId,
          resourceData,
        );

        if (data.result === 'success') {
          this.file[i].img = null;
          this.file2[i].img = null;
          this.preFilePath = '';
          const emitData = {
            resourceId: resourceId,
            lriId: this.propsLriId,
            resourceType: 1,
          };
          this.$emit('getResourceAfterAdd', emitData);
          this.logResult = '수정되었습니다.';
          this.showSystemAlert = true;
        }
      } catch (error) {
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'OutRange') {
          this.showSystemAlert = true;
          this.logResult =
            '소재의 시작/종료는 지면의 시작, 종료일 범위 내에서만 설정 가능합니다.';
        }
      }
    },

    updateDateRange(resource) {
      resource.start_at = resource.dateRange.startDate;
      resource.end_at = resource.dateRange.endDate;
    },

    openRemoveConfirmPopup(item, i) {
      if (!item.id) {
        if (this.propsResources.length > 1) {
          this.propsResources.splice(i, 1);
          this.valid.splice(i, 1);
        } else {
          return false;
        }
      } else {
        this.editItem = item;
        this.editItemIndex = i;
        this.logResult = '정말로 삭제하시겠습니까?';
        this.confirmSystemAlert = true;
      }
    },

    async removeResource() {
      bus.$emit('start:spinner');
      this.confirmSystemAlert = false;
      try {
        const campaignId = this.$route.params.id;
        const inventoryId = this.propsInventoryId;
        const lineItemId = this.propsLineItemId;
        const lriId = this.propsLriId;
        const resourceId = this.editItem.id;
        const { data } = await deleteResource(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          resourceId,
        );

        if (data.result === 'success') {
          //validation check 순번 삭제
          this.valid.splice(this.editItemIndex, 1);

          this.file[this.editItemIndex].name = null;
          this.file[this.editItemIndex].thumb = null;
          this.file[this.editItemIndex].img = null;
          this.file[this.editItemIndex].type = 1;

          this.file2[this.editItemIndex].name = null;
          this.file2[this.editItemIndex].thumb = null;
          this.file2[this.editItemIndex].img = null;
          this.file2[this.editItemIndex].type = 1;

          this.logResult = '삭제되었습니다.';
          this.showSystemAlert = true;
          const emitData = {
            resourceId: resourceId,
            lriId: this.propsLriId,
            resourceType: 1,
          };
          this.$emit('getResourceAfterDelete', emitData);
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    appendResource() {
      //validate check 추가
      this.valid.push(false);

      this.file.push({
        img: null,
        name: null,
        thumb: null,
        type: 1,
      });
      this.file2.push({
        img: null,
        name: null,
        thumb: null,
        type: 1,
      });
      this.defaultResource.dateRange.startDate = this.defaultStartAt;
      this.defaultResource.dateRange.endDate = this.defaultEndAt;
      this.defaultResource.start_at = this.defaultStartAt;
      this.defaultResource.end_at = this.defaultEndAt;
      this.propsResources.push(
        JSON.parse(JSON.stringify(this.defaultResource)),
      );
    },
    viewHistory(i) {
      this.showResources = true;
      this.editItemIndex = i;
    },
    updateHistoryImg(data) {
      if (data !== null) {
        this.preFilePath = data.file;
        let fileName1 = '';
        let fileName2 = '';
        if (data.file.includes('%s')) {
          fileName1 = data.file.replace('/%s', '/h');
          fileName2 = data.file.replace('/%s', '/u');
        }
        this.file[this.editItemIndex] = {
          thumb: fileName1,
        };
        this.file2[this.editItemIndex] = {
          thumb: fileName2,
        };
      }
    },
  },
  created() {
    this.setDetailResourceIfEmpty();
    if (this.file.length !== this.resources.length) {
      this.file = [];
      for (let i = 0; i < this.resources.length; i++) {
        this.file.push({
          img: null,
          name: null,
          thumb: null,
          type: 1,
        });
      }
    }
    if (this.file2.length !== this.resources.length) {
      this.file2 = [];
      for (let i = 0; i < this.resources.length; i++) {
        this.file2.push({
          img: null,
          name: null,
          thumb: null,
          type: 1,
        });
      }
    }
  },
  mounted() {},
  beforeUpdate() {
    if (this.file.length !== this.resources.length) {
      this.file = [];
      for (let i = 0; i < this.resources.length; i++) {
        this.file.push({
          img: null,
          name: null,
          thumb: null,
          type: 1,
        });
      }
    }
    if (this.file2.length !== this.resources.length) {
      this.file2 = [];
      for (let i = 0; i < this.resources.length; i++) {
        this.file2.push({
          img: null,
          name: null,
          thumb: null,
          type: 1,
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.holev-gap {
  .resource-cont {
    padding-left: 118px !important;
    padding-right: 0px !important;
    padding-top: 0px !important;
  }
  .btn-resource-add {
    position: absolute;
    top: 24px;
    right: 64px;
  }
}
</style>
